enum Oikeudet {
    Luku = "luku",
    Kirjoitus = "kirjoitus",
    Raportointi = "raportointi",
}

export default Oikeudet
